import {Rules, Validation, ValueObject } from '@singularsystems/neo-core';

export default class CededClientInvestmentCriteria extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    public entityId: number | null = null;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Ceded Client Investment Criteria";
    }
}